const SUFFIX_CURRENCY_SYMBOLS = new Set(['SAR', 'Ft', 'RON', 'zł']);
const SPACED_PREFIX_CURRENCY_SYMBOLS = new Set(['RM', 'Bs', 'R']);
const ZERO_DECIMAL_PREFIX_CURRENCY_SYMBOLS = new Set(['¥']);

export function usesZeroDecimalPrefixCurrencyFormat(currencySymbol?: string | null): boolean {
  return ZERO_DECIMAL_PREFIX_CURRENCY_SYMBOLS.has(currencySymbol ?? '');
}

export function formatZeroDecimalPrefixCurrencyAmount(
  value: number | undefined,
  currencySymbol: string,
): string {
  return `${currencySymbol}${Math.round(Number(value ?? 0))}`;
}

export function usesSpacedPrefixCurrencyFormat(currencySymbol?: string | null): boolean {
  return SPACED_PREFIX_CURRENCY_SYMBOLS.has(currencySymbol ?? '');
}

export function formatSpacedPrefixCurrencyAmount(
  value: number | undefined,
  currencySymbol: string,
): string {
  const n = Number(value ?? 0);
  const rounded = Math.round(n * 100) / 100;
  return `${currencySymbol} ${rounded.toFixed(2)}`;
}

export function usesCopAmountFormat(
  currency?: string | null,
  currencySymbol?: string | null,
): boolean {
  return currency === 'COP' || currencySymbol === 'COP';
}

export function usesSuffixCurrencyFormat(currencySymbol?: string | null): boolean {
  return SUFFIX_CURRENCY_SYMBOLS.has(currencySymbol ?? '');
}

export function formatSuffixCurrencyAmount(
  value: number | undefined,
  currencySymbol: string,
): string {
  const n = Number(value ?? 0);
  if (currencySymbol === 'Ft') {
    const rounded = Math.round(n);
    const neg = rounded < 0;
    const abs = Math.abs(rounded);
    return `${neg ? '-' : ''}${formatSpaceThousands(String(abs))} ${currencySymbol}`;
  }
  const rounded = Math.round(n * 100) / 100;
  return `${rounded.toFixed(2)} ${currencySymbol}`;
}

function formatDotsThousands(intDigits: string): string {
  return intDigits.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

function formatSpaceThousands(intDigits: string): string {
  return intDigits.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export function formatCopAmount(value: number | undefined, currencySymbol: string): string {
  const n = Number(value ?? 0);
  const rounded = Math.round(n * 100) / 100;
  const neg = rounded < 0;
  const abs = Math.abs(rounded);
  const [intS, decS] = abs.toFixed(2).split('.');
  const intFormatted = formatDotsThousands(intS);
  const numPart = decS === '00' ? intFormatted : `${intFormatted},${decS}`;
  return `${currencySymbol} ${neg ? '-' : ''}${numPart}`;
}
